import { SortDescriptor } from '@progress/kendo-data-query';

import {
  DlqMessage,
  DlqMessageHeader
} from '@gms/monitoring-api';
import {
  createSuccessState,
  emptyRequestStatus,
  IDataState,
  IRequestStatus,
} from 'app/store/app/app.models';

export interface IDlqState {
  messages: Array<DlqMessageHeader>;
  totalMessageCount: number;
  loading: boolean;
  error: Error | null;
  pagination: {
    pageNumber: number;
    pageSize: number;
  };
  sortDescriptors: SortDescriptor[];
  message: DlqMessage;
  messageDeleted: boolean,
  redriveError: Error | null,
  deleteError: Error | null;
  approveError: Error | null;
  approveSuccess: boolean;
  submitNewMessageSuccess: boolean;
  submitNewMessageError: Error | null;
  multiDeleteSuccess: boolean;
  multiDeleteError: Error | null;
}

export const initialDlqState: IDlqState = {
  messages: [],
  totalMessageCount: 0,
  sortDescriptors: [
    {
      field: 'messageTimestamp',
      dir: 'desc',
    },
  ],
  loading: false,
  error: null,
  pagination: {
    pageNumber: 0,
    pageSize: 20,
  },
  message: {} as DlqMessage,
  messageDeleted: false,
  redriveError: null,
  deleteError: null,
  approveError: null,
  approveSuccess: false,
  submitNewMessageSuccess: false,
  submitNewMessageError: null,
  multiDeleteSuccess: false,
  multiDeleteError: null,
}
